import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import InvoiceDetails from "./InvoiceDetails";
import { InvoiceDataType } from "../../../api/invoice";

interface InvoiceDetailsRowProps {
  rowIndex: number;
  data?: InvoiceDataType;
}

const InvoiceDetailsRow: React.FC<InvoiceDetailsRowProps> = ({
  data,
  rowIndex,
}) => {
  const formData = useSelector((state: RootState) => state.formData);
  const transformedData = {
    bankDetails: {
      ...data?.bank,
      ifsc: data?.bank?.ifscCode,
      bankName: data?.bank?.name,
    },
    row1: {
      left: {
        CIN: data?.company?.cin ?? "",
        PAN: data?.company?.pan ?? "",
        GST: data?.company?.gst ?? "",
        GSTStateCode: data?.company?.gstStateCode ?? "",
      },
      right: {
        invoiceNo: data?.excise?.exciseID ?? "",
        invoiceDate: data?.other?.invoiceDate,
        piNo: "",
        dcNo: "",
      },
      service: {
        invoiceNo:
          formData?.serviceID !== undefined && formData?.serviceID !== null
            ? formData.serviceID.length > 0
              ? formData.serviceID
              : data?.other?.invoiceId
                ? `SER/25/${data.other.invoiceId}`
                : ""
            : data?.service?.serviceID
              ? data.service.serviceID
              : data?.other?.invoiceId
                ? `SER/25/${data.other.invoiceId}`
                : "",
        invoiceDate: data?.other?.invoiceDate ?? "",
      },
    },
    row2: {
      left: {
        exportPermitNoAndDate: "",
        importPermitNoAndDate: "",
        customerExecRegNo: data?.other?.exciseRegistrationNumber ?? "",
        customerExecLeafNo: data?.other?.customerExecLeafNo,
      },
      right: {
        transporter: data?.other?.transporter ?? "",
        transporterPermitNo: data?.other?.transporterPermitNo ?? "",
        vehicleNo: data?.other?.vehicleNumber ?? "",
      },
    },
  };

  // Clone the original InvoiceData object to avoid modifying the original
  const updatedInvoiceData = {
    ...transformedData,
    row1: {
      ...transformedData.row1,
      right: {
        ...transformedData.row1.right,
        invoiceNo: formData.exciseID || data?.excise?.exciseID || "",
      },
    },
    row2: {
      ...transformedData.row2,
      left: {
        ...transformedData.row2.left,
        customerExecLeafNo:
          formData.customerExecLeafNo || data?.other?.customerExecLeafNo || "",
      },
      right: {
        ...transformedData.row2.right,
        transporterPermitNo:
          formData.transporterPermitNo ||
          data?.other?.transporterPermitNo ||
          "",
        transporter: formData.transporter || data?.other?.transporter || "",
        vehicleNo: formData.vehicleNumber || data?.other?.vehicleNumber || "",
      },
    },
  };

  // Define which data to render for each row
  const dataToRender =
    rowIndex === 0
      ? transformedData.row1.left
      : rowIndex === 1
        ? transformedData.row1.right
        : rowIndex === 2
          ? updatedInvoiceData.row2.left
          : rowIndex === 3
            ? updatedInvoiceData.row2.right
            : rowIndex === 4
              ? transformedData.row1.service || {}
              : {};

  // Conditionally define styles to pass to InvoiceDetails
  const rowStyles = rowIndex === 0 ? { borderBottom: "3px solid black" } : {};
  return <InvoiceDetails data={dataToRender} rowStyles={rowStyles} />;
};

export default InvoiceDetailsRow;
